module.exports = __webpack_public_path__ + "img/sec1.e28fd143.png";